import React from 'react';
import styled from 'styled-components';
const EmptyListWrapper = styled.div `
  height: 265px;
  color: #697d8e;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  background-image: linear-gradient(#f5f5f6, 0.5%, white);
  padding-top: 40px;
`;
const EmptyListHeader = styled.div `
  color: #29333d;
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
  letter-spacing: 0.04px;
  margin: 8px;
`;
const EmptyListDescription = styled.div `
  width: 325px;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.18px;
  text-align: center;
  margin: 8px;
  padding: 8px;
`;
const EmptyAccountsList = ({ emptyListHeader, emptyListDescription, }) => {
    return (React.createElement(EmptyListWrapper, null,
        React.createElement(EmptyListHeader, null, emptyListHeader),
        React.createElement(EmptyListDescription, null, emptyListDescription)));
};
export default EmptyAccountsList;
